import { Column } from "@/components/Column";
import { Text } from "@/components/Text";
import { SadieSimulatorPipelineEntry } from "@/types";

const STAGE_LABELS: Record<SadieSimulatorPipelineEntry["stage"], string> = {
  REVIEW: "Review",
  SCREENING: "Screening",
  INTERVIEW: "Interview",
  OFFER: "Offer",
  REJECTED: "Rejected",
  CLOSED: "Closed",
};

// A fixture pipeline, one line per application, the way the status check
// sees it. The submitted marker is for the tester only: Sadie reads it to
// tell early cold feet from late, and never says it to the worker.
export const SadieSimulatorPipelineEntries = ({
  entries,
  showSubmitted = false,
}: {
  entries: SadieSimulatorPipelineEntry[];
  showSubmitted?: boolean;
}) =>
  entries.length > 0 ? (
    <Column className="gap-0.5 pl-1">
      {entries.map((entry, i) => (
        <Text className="text-xs text-slate-500" key={i}>
          {entry.role}
          {entry.location ? `, ${entry.location}` : ""}:{" "}
          {STAGE_LABELS[entry.stage]}
          {showSubmitted && entry.submitted ? ", submitted" : ""}
        </Text>
      ))}
    </Column>
  ) : null;
